import i18n from '../i18n'
import Api from './api'
import {projectInfo} from '../../../utils'
const pageText = window.fe.getPageText(i18n)
export default {
  'paas-shortText': {
    CONTAIN: {
      tagName: 'el-input',
      symbol: 'CONTAIN',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseEnter
      }
    },
    EQUAL: {
      tagName: 'el-input',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseEnter
      }
    },
    START_WITH: {
      tagName: 'el-input',
      symbol: 'START_WITH',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseEnter
      }
    },
    default: {
      tagName: 'el-input',
      symbol: 'CONTAIN',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseEnter
      }
    }
  },
  'paas-textArea': {
    CONTAIN: {
      tagName: 'el-input',
      symbol: 'CONTAIN',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseEnter
      }
    },
    EQUAL: {
      tagName: 'el-input',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseEnter
      }
    },
    START_WITH: {
      tagName: 'el-input',
      symbol: 'START_WITH',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseEnter
      }
    },
    default: {
      tagName: 'el-input',
      symbol: 'CONTAIN',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseEnter
      }
    }
  },
  'paas-autoNumber': {
    CONTAIN: {
      tagName: 'el-input',
      symbol: 'CONTAIN',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseEnter
      }
    },
    EQUAL: {
      tagName: 'el-input',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseEnter
      }
    },
    START_WITH: {
      tagName: 'el-input',
      symbol: 'START_WITH',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseEnter
      }
    },
    default: {
      tagName: 'el-input',
      symbol: 'CONTAIN',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseEnter
      }
    }
  },
  'paas-singleChoice': {
    EQUAL: {
      tagName: 'single-choice',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        clearable: true
      },
      field: {uiComponent: 1}
    },
    default: {
      tagName: 'single-choice',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        clearable: true
      },
      field: {uiComponent: 1}
    }
  },
  'paas-multipleChoices': {
    BELONG: {
      tagName: 'multiple-choices',
      symbol: 'BELONG',
      attrs: {
        'collapse-tags': true,
        clearable: true,
        size: 'mini'
      },
      field: {uiComponent: 1}
    },
    default: {
      tagName: 'multiple-choices',
      symbol: 'BELONG',
      attrs: {
        'collapse-tags': true,
        clearable: true,
        size: 'mini'
      },
      field: {uiComponent: 1}
    }
  },
  'paas-boole': {
    EQUAL: {
      tagName: 'filter-boole',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseSelectA
      }
    },
    default: {
      tagName: 'filter-boole',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseSelectA
      }
    }
  },
  'paas-number': {
    BETWEEN_EQUAL: {
      defaultValue: ['', ''],
      tagName: 'list-search-input-number',
      symbol: 'BETWEEN_EQUAL',
      attrs: {
        size: 'mini',
        placeholder: pageText.pleaseEnter,
        clearable: true
      }
    },
    default: {
      defaultValue: ['', ''],
      tagName: 'list-search-input-number',
      symbol: 'BETWEEN_EQUAL',
      attrs: {
        size: 'mini',
        placeholder: pageText.pleaseEnter,
        clearable: true
      }
    }
  },
  'paas-currency': {
    BETWEEN_EQUAL: {
      defaultValue: ['', ''],
      tagName: 'list-search-input-number',
      symbol: 'BETWEEN_EQUAL',
      attrs: {
        size: 'mini',
        placeholder: pageText.pleaseEnter,
        clearable: true
      }
    },
    default: {
      defaultValue: ['', ''],
      tagName: 'list-search-input-number',
      symbol: 'BETWEEN_EQUAL',
      attrs: {
        size: 'mini',
        placeholder: pageText.pleaseEnter,
        clearable: true
      }
    }
  },
  'paas-percentage': {
    BETWEEN_EQUAL: {
      defaultValue: ['', ''],
      tagName: 'list-search-input-number',
      symbol: 'BETWEEN_EQUAL',
      attrs: {
        size: 'mini',
        placeholder: pageText.pleaseEnter,
        clearable: true
      }
    },
    default: {
      defaultValue: ['', ''],
      tagName: 'list-search-input-number',
      symbol: 'BETWEEN_EQUAL',
      attrs: {
        size: 'mini',
        placeholder: pageText.pleaseEnter,
        clearable: true
      }
    }
  },
  'paas-date': {
    DATE_BETWEEN_EQUAL: {
      tagName: 'filter-date-between-equal',
      symbol: 'DATE_BETWEEN_EQUAL',
      attrs: {
        size: 'mini',
        type: 'date',
        placeholder: pageText.selectDate,
        'value-format': 'yyyy-MM-dd'
      }
    },
    default: {
      tagName: 'filter-date-between-equal',
      symbol: 'DATE_BETWEEN_EQUAL',
      attrs: {
        size: 'mini',
        type: 'date',
        placeholder: pageText.selectDate,
        'value-format': 'yyyy-MM-dd'
      }
    }
  },
  'paas-dateTime': {
    DATE_BETWEEN_EQUAL: {
      tagName: 'filter-date-between-equal',
      symbol: 'DATE_BETWEEN_EQUAL',
      attrs: {
        size: 'mini',
        type: 'datetime',
        placeholder: pageText.selectDate,
        'value-format': 'yyyy-MM-dd HH:mm:ss'
      }
    },
    default: {
      tagName: 'filter-date-between-equal',
      symbol: 'DATE_BETWEEN_EQUAL',
      attrs: {
        size: 'mini',
        type: 'datetime',
        placeholder: pageText.selectDate,
        'value-format': 'yyyy-MM-dd HH:mm:ss'
      }
    }
  },
  'paas-period': {
    DATE_BETWEEN_EQUAL: {
      tagName: 'filter-date-between-equal',
      symbol: 'DATE_BETWEEN_EQUAL',
      attrs: {
        size: 'mini',
        isPermanent: false,
        'value-format': 'yyyy-MM-dd HH:mm:ss'
      }
    },
    default: {
      tagName: 'filter-date-between-equal',
      symbol: 'DATE_BETWEEN_EQUAL',
      attrs: {
        size: 'mini',
        isPermanent: false,
        'value-format': 'yyyy-MM-dd HH:mm:ss'
      }
    }
  },
  'paas-lookupRelationship': {
    EQUAL: {
      tagName: 'lookupRelationship',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        placeholder: pageText.pleaseEnter,
        showAddIcon: false,
        getMainFieldListApi: Api.getMainFieldList
      },
      inValueHandle ({props}, value) {
        const key = props?.abilityResponseParams?.uniqueKey
        return {
          [key]: value
        }
      },
      outValueHandle ({props}, value) {
        const key = props?.abilityResponseParams?.uniqueKey
        return value?.[key]
      }
    },
    default: {
      tagName: 'lookupRelationship',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        placeholder: pageText.pleaseEnter,
        showAddIcon: false,
        getMainFieldListApi: Api.getMainFieldList
      }
    }
  },
  'paas-masterDetailRelationship': {
    EQUAL: {
      tagName: 'MasterRelationship',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        placeholder: pageText.pleaseEnter,
        showAddIcon: false,
        getMainFieldListApi: Api.getMainFieldList
      }
    },
    default: {
      tagName: 'MasterRelationship',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        placeholder: pageText.pleaseEnter,
        showAddIcon: false,
        getMainFieldListApi: Api.getMainFieldList
      }
    }
  },
  'paas-personnel': {
    CONTAIN: {
      tagName: 'el-input',
      symbol: 'CONTAIN',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.pleaseEnter
      }
    },
    EQUAL: function (field) {
      const {purDataOrigin, surDataOrigin} = field
      const purOrMall = projectInfo.include('pur') || projectInfo.include('mall')
      return {
        tagName: 'personnel',
        symbol: 'EQUAL',
        attrs: {
          disabled: purOrMall
            ? !purDataOrigin && surDataOrigin
            : !surDataOrigin && purDataOrigin,
          defaultParams: {
            queryStatus: 1
          },
          size: 'small',
          valueKey: 'id',
          placeholder: pageText.pleaseEnter
        }
      }
    },
    default: {
      tagName: 'personnel',
      symbol: 'EQUAL',
      attrs: {
        defaultParams: {
          queryStatus: 1
        },
        size: 'small',
        valueKey: 'id',
        placeholder: pageText.pleaseEnter
      }
    }
  },
  'paas-department': {
    EQUAL_INCLUDE_SUB: {
      tagName: 'department',
      symbol: 'EQUAL_INCLUDE_SUB',
      attrs: {
        size: 'mini',
        valueKey: 'code',
        placeholder: pageText.pleaseEnter
      }
    },
    EQUAL: {
      tagName: 'department',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        valueKey: 'id',
        placeholder: pageText.pleaseEnter
      }
    },
    default: {
      tagName: 'department',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        valueKey: 'id',
        placeholder: pageText.pleaseEnter
      }
    }
  },
  'paas-region': {
    BELONG_MULTI: {
      tagName: 'sy-region',
      symbol: 'BELONG_MULTI',
      attrs: {
        size: 'small',
        height: 30
      }
    },
    EQUAL: {
      tagName: 'sy-region',
      symbol: 'EQUAL',
      attrs: {
        size: 'small',
        height: 30
      }
    },
    default: {
      tagName: 'sy-region',
      symbol: 'EQUAL',
      attrs: {
        size: 'mini',
        height: 30
      }
    }
  },
  'paas-address': {
    default: {
      tagName: 'el-input',
      symbol: 'CONTAIN',
      attrs: {
        size: 'mini',
        clearable: true,
        placeholder: pageText.searchPlaceholderFuzzy
      }
    }
  },
  'default': {
    tagName: 'el-input',
    symbol: 'CONTAIN',
    attrs: {
      size: 'mini',
      clearable: true,
      placeholder: pageText.pleaseEnter
    }
  }
}
